import { selectors } from 'modules/common';
import { backend, domain } from 'modules/data';
import { SelectNetSuiteCustomCompanyFieldsAnswer } from 'modules/data/backend';
import { LineItem } from 'pages/requestForm/selectors/types/ColumnDefinition';
import { CustomFieldAccessLevel, CustomFieldType } from 'shared/constants';

import { NetSuiteCustomFieldReferenceItem } from '../../types';

export interface NetSuiteCustomFieldsProps {
    company: selectors.types.ExpandedCompany;
    customFieldReference: NetSuiteCustomFieldReferenceItem[];
    customFieldList: SelectNetSuiteCustomCompanyFieldsAnswer;
}

export interface CustomFieldsStateItem extends LineItem {
    originalId: string | null;
    referenceValue: NetSuiteCustomFieldReferenceItem | null;
    approvalmaxFieldName: string | null;
    [WorkflowAccessLevelType.VendorBillWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.POWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.ExpenseReportWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.SalesOrderWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.VRAWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.RAWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.BillPaymentWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.InvoiceWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.JournalEntryWorkflowAccessLevel]: CustomFieldAccessLevel;
    [WorkflowAccessLevelType.VendorWorkflowAccessLevel]: CustomFieldAccessLevel;
    usedInWorkflows: domain.IntegrationCode[] | null;
}

export type AccessLevelFieldKeys = NonNullable<
    {
        [K in keyof CustomFieldsStateItem]: CustomFieldsStateItem[K] extends CustomFieldAccessLevel ? K : never;
    }[keyof CustomFieldsStateItem]
>;

export type FieldsByIntegrationCode = Partial<Record<domain.IntegrationCode, backend.NetSuiteCustomFieldWorkflowData>>;

export interface ValidateFieldChangesArgs {
    newFieldState?: CustomFieldAccessLevel;
    currentFieldsState: CustomFieldsStateItem[];
    integrationCode: domain.IntegrationCode;
    li: CustomFieldsStateItem;
}

export interface SaveOptions {
    company: selectors.types.ExpandedCompany;
    bodyFieldsState: CustomFieldsStateItem[];
    lineFieldsState: CustomFieldsStateItem[];
    segmentFieldsState: CustomFieldsStateItem[];
    setShowErrors: (value: boolean) => void;
}

export interface UseCustomFieldsTableOptions {
    type: CustomFieldType;
    company: selectors.types.ExpandedCompany;
    availableFields: NetSuiteCustomFieldReferenceItem[];
    showErrors: boolean;
    initializer: () => CustomFieldsStateItem[];
}

export enum WorkflowAccessLevelType {
    VendorBillWorkflowAccessLevel = 'vendorBillWorkflowAccessLevel',
    POWorkflowAccessLevel = 'poWorkflowAccessLevel',
    ExpenseReportWorkflowAccessLevel = 'expenseReportWorkflowAccessLevel',
    SalesOrderWorkflowAccessLevel = 'salesOrderWorkflowAccessLevel',
    VRAWorkflowAccessLevel = 'vraWorkflowAccessLevel',
    RAWorkflowAccessLevel = 'raWorkflowAccessLevel',
    BillPaymentWorkflowAccessLevel = 'billPaymentWorkflowAccessLevel',
    InvoiceWorkflowAccessLevel = 'invoiceWorkflowAccessLevel',
    JournalEntryWorkflowAccessLevel = 'journalEntryWorkflowAccessLevel',
    VendorWorkflowAccessLevel = 'vendorWorkflowAccessLevel',
}
